function getBaseLen(d) {
  const m = 1000000;
  const k = 1000;

  if (d >= m) return `${(Math.round((10 * d) / m) / 10).toLocaleString()} Mb`;
  if (d >= k) return `${(Math.round((10 * d) / k) / 10).toLocaleString()} Kb`;
  return `${Math.round(d).toLocaleString()} bp`;
}

export default getBaseLen;
